export default __webpack_public_path__ + "static/media/csharp.00281f6b.jpg";